import { ButtonRadioGroupField, CheckboxField } from '@cian/components';
import * as React from 'react';
import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../common/state';
import { ELayoutType, IJsonQuery } from '../../../../json_query';
import { isRoomTypeAvailable, isWithLayoutAvailable } from '../../../../utils/layout';
import { changeLayoutType } from '../../../state/advanced/layout';
import { InlineParam, Row, InlineBlock } from '../markup';
import { changeWithLayout } from '../../../state/with_layout';

interface ILayoutProps {
  jsonQuery: IJsonQuery;

  onLayoutChanged(value: ELayoutType): void;
  onWithLayoutChanged(value: boolean): void;
}

const getChangedLayoutType = (value: string): ELayoutType => {
  if (value === 'IsolatedRooms') {
    return ELayoutType.IsolatedRooms;
  } else if (value === 'UnitedRooms') {
    return ELayoutType.UnitedRooms;
  } else {
    return ELayoutType.Any;
  }
};

const layout: React.StatelessComponent<ILayoutProps> = props => {
  const { jsonQuery } = props;

  const withLayout = jsonQuery.with_layout && jsonQuery.with_layout.value;
  const roomType = (jsonQuery.room_type && jsonQuery.room_type.value) || ELayoutType.Any;

  let radioGroupValue = '';
  if (roomType === ELayoutType.IsolatedRooms) {
    radioGroupValue = 'IsolatedRooms';
  } else if (roomType === ELayoutType.UnitedRooms) {
    radioGroupValue = 'UnitedRooms';
  }

  const withLayoutAvailable = isWithLayoutAvailable(jsonQuery);
  const roomTypeAvailable = isRoomTypeAvailable(jsonQuery);

  if (!withLayoutAvailable && !roomTypeAvailable) {
    return null;
  }

  return (
    <Row title="Планировка">
      {withLayoutAvailable && (
        <InlineParam customStyles={{ marginRight: '20px' }}>
          <CheckboxField
            onValueChange={props.onWithLayoutChanged}
            value={withLayout || false}
            label="Схема планировки"
          />
        </InlineParam>
      )}
      {roomTypeAvailable && (
        <InlineBlock>
          <ButtonRadioGroupField
            uncheckable
            value={radioGroupValue}
            onValueChange={value => props.onLayoutChanged(getChangedLayoutType(value))}
            values={[
              { value: 'IsolatedRooms', label: 'Изолированные комнаты' },
              { value: 'UnitedRooms', label: 'Смежные комнаты' },
            ]}
          />
        </InlineBlock>
      )}
    </Row>
  );
};

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    jsonQuery: state.filters.jsonQuery,
  }),
  (dispatch: Dispatch) => ({
    onWithLayoutChanged: (value: boolean) => {
      dispatch(changeWithLayout(value));
    },
    onLayoutChanged: (value: ELayoutType) => {
      dispatch(changeLayoutType(value));
    },
  }),
)(layout);
